



































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import moment from 'moment-timezone';
import { Spinner } from 'vue-image-spinner2';

@Component({
    name: 'location-detail-modal',
    components: {
        Spinner,
    },
    filters: {
        date(val) {
            return val == null ? 'YYYY/MM/DD' : moment(val).format('YYYY/MM/DD');
        },
    },
    computed: {
        ...mapState('locations', ['activeLocation', 'activeLocationLoading']),
    },
})
export default class LocationDetailModal extends Vue {
    //
    private activeLocation!: any;
    private activeLocationLoading!: any;
    public dataPdf: any = '';
    public pdfSrc: string = '';
    public products_location: any = [];
    public fields_product_location: any = ['id', 'qty', 'price'];

    public dateRange: any = {
        date: null,
    };
    singleDatePicker: any = 'range';

    onSaveLocation() {
        console.log(this.activeLocation);
        this.$store.dispatch('locations/postOne', {
            vm: this,
            data: this.activeLocation,
        });
    }

    onDeleteLocation() {
        this.$store.dispatch('locations/deleteOne', { id: this.activeLocation.id, vm: this });
        setTimeout(() => {
            this.$store.dispatch('locations/getAll');
            this.$bvModal.hide('location-detail-modal');
        });
    }
}
